<template>
    <a-modal
        :visible="visible"
        :title="mode === 'create' ? '新增客服' : '修改客服信息'"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :after-close="after_close"
        :width="480"
    >
        <a-alert message="上传图片时，请留意图片大小，防止图片太大导致加载过慢。" type="warning" style="margin-bottom:24px" show-icon />

        <a-form-model :model="form" :rules="rules" ref="service-create">
            <a-form-model-item label="头像（推荐使用200*200的正方形图片）" prop="avatar">
                <a-upload
                    class="img-uploader-avatar"
                    list-type="picture-card"
                    name="file"
                    :action="action"
                    :withCredentials="true"
                    :show-upload-list="false"
                    @change="(info) => on_upload_change(info, 'avatar')"
                    :headers="{ 'x-identity': 'manager' }"
                    accept="image/png, image/jpeg"
                >
                    <img v-if="form.avatar" :src="form.avatar" class="favicon" style="width: 100%;" />
                    <div class="upload" v-else>
                        <a-icon :type="uploading_avatar ? 'loading' : 'plus'" />

                        <div class="ant-upload-text">上传头像</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="后台的用户ID" prop="user_id" v-if="mode == 'create'">
                <a-input v-model="form.user_id"></a-input>
            </a-form-model-item>

            <a-form-model-item label="名称" prop="name">
                <a-input v-model="form.name"></a-input>
            </a-form-model-item>
            <a-form-model-item label="工号" prop="no">
                <a-input v-model="form.no"></a-input>
            </a-form-model-item>

            <a-form-model-item label="电话" prop="mobile">
                <a-input v-model="form.mobile"></a-input>
            </a-form-model-item>

            <a-form-model-item label="QQ" prop="qq">
                <a-input v-model="form.qq"></a-input>
            </a-form-model-item>

            <a-form-model-item label="微信号" prop="wechat_id" extra="请填写能够在添加好友时检索到的ID">
                <a-input v-model="form.wechat_id"></a-input>
            </a-form-model-item>

            <a-form-model-item label="微信二维码（推荐使用较为清新的正方形图片）" prop="wechat_qrcode">
                <a-upload
                    class="img-uploader-qrcode"
                    list-type="picture-card"
                    name="file"
                    :action="action"
                    :withCredentials="true"
                    :show-upload-list="false"
                    @change="(info) => on_upload_change(info, 'wechat_qrcode')"
                    :headers="{ 'x-identity': 'manager' }"
                    accept="image/png, image/jpeg"
                >
                    <img v-if="form.wechat_qrcode" :src="form.wechat_qrcode" class="favicon" style="width: 100%;" />
                    <div class="upload" v-else>
                        <a-icon type="plus" />
                        <div class="ant-upload-text">上传二维码</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="咨询链接" prop="url" extra="如果存在可以唤起的咨询链接，请填写带http的完整链接地址">
                <a-input v-model="form.url"></a-input>
            </a-form-model-item>

            <a-form-model-item label="介绍">
                <a-input type="textarea" v-model="form.description"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    import env from "../../../../env";
    let init_form = {
        name: null,
        user_id: null,
        avatar: null,
        description: null,
        mobile: null,
        wechat_id: null,
        wechat_qrcode: null,
        qq: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            mode: {
                default: "create",
            },
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        data() {
            return {
                submitting: false,
                action: env.base_url + "service/upload",
                uploading_avatar: false,
                form: null,
                rules: {
                    name: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入名称",
                        },
                    ],
                    mobile: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入电话",
                        },
                    ],
                    user_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入用户ID",
                        },
                    ],
                    no: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入客服工号",
                        },
                    ],
                    wechat_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请填写微信号",
                        },
                    ],
                    qq: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请填写QQ号码",
                        },
                    ],
                    wechat_qrcode: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请上传微信二维码",
                        },
                    ],
                },
            };
        },
        watch: {
            visible(v) {
                if (v && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            this.form[v] = this.record[v];
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["service-create"].validate((valid) => {
                    if (valid) {
                        if (this.mode === "create") {
                            return this.on_create();
                        } else {
                            return this.on_edit();
                        }
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_create() {
                this.submitting = true;
                this.$http
                    .post("/auth/service/", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$emit("load");
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            on_edit() {
                this.submitting = true;
                this.$http
                    .put("/auth/service/" + this.record.id, this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$emit("load");
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    .catch(() => {})

                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.$refs["service-create"].resetFields();
                this.visible_parent = false;
                this.form = JSON.parse(JSON.stringify(init_form));
            },
            on_upload_change(info, field) {
                if (info.file.status === "uploading") {
                    this["uploading_" + field] = true;
                    return;
                }
                if (info.file.status === "done") {
                    this["uploading_" + field] = false;
                    if (info.file.response.success) {
                        this.form[field] = info.file.response.data.url;
                    } else {
                        this.$error({
                            title: "失败",
                            content: info.file.response.message,
                        });
                    }
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} 上传失败.`);
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    .img-uploader-avatar {
        /deep/.ant-upload {
            overflow: hidden;
            border-radius: 50%;
            .ant-upload {
                padding: 0 !important;
            }
        }
    }
    .img-uploader-qrcode {
        /deep/.ant-upload {
            overflow: hidden;
            border-radius: 5px;
            .ant-upload {
                padding: 0 !important;
            }
        }
    }
</style>
